// import Logout from "../pages/mine/setting/logout";

export default {
//-----config----------------------------------------------------------------
    'host': '',

//---h5 相关--------------------------------------------------------

    //-custom--------------------
    'mine': '/mine',     //我的
    'auth': '/auth',     //认证页面
    //--------------------------------------
    'errorUrl' : '/instabilityOf', //'/jointLogonFail',     //准入失败页面
    'loanDetailUrl' : '/veryOf', // '/loanDetailsV3',     //借款详情页
    'orderUrl' :  '/twoPureblood', //'/loanDetailsV3',     //订单详情页面
    'confirmUrl' : '/ofSeries', //'/confirmOfLoanV3',     //借款详情页
    'confirmNewUrl' : '/sendIn', //'/confirmUrl',     //后置确认详情页
    'confirmOfPeriod' : '/inLies', //'/confirmOfLoanV3',     //借款详情页
    'repayUrl' :  '/betweenOf', //'/repaymentOfPeriod',     //还款页
    'customerService' :  '/relyNovels', //'/loanDetailsV3',     //订单详情页面
    'loanAgreement' :  '/muggleNo', //'/loanDetailsV3',     //借款协议
    'aboutUs' :  '/magicalThree', //'/loanDetailsV3',     //关于我们
    'privacyPolicy' :  '/suchOf', //'/privacyPolicy',      //隐私协议
    'repayDelayUrl' : '/bothPurity',  //展期
    'complaint' : '/ofThese',  //客服案件投诉入口
    'bindBank' : '/toStudents',  //绑卡页面

    'logout': '/Logout',   //设置页



    'setting' : 'pureblood',   //设置页
    'main' : 'not',     //首页
    'login' : 'celebrating',     //登录
    'order' : 'tools',          //订单
    'productDetail' : 'bronze',    //产品详情
    
    'landingPage': '/ddd',    //落地页
    'faceDetection': '/FaceDetection',    //人脸识别
    //--------值映射-认证项------------------------------

    'banner': "wizarda",
    'largeCard': "wizardb",
    'smallCard': "wizardc",
    'productList': "wizardd",

    "public": "area", // ocr认证
    "personal": "areb", // 个人信息
    "job": "arec", // 个人信息
    "ext": "ared", // 紧急联系人
    "bank": "aree", // 绑卡

    "enum": "resulta",
    "txt": "resultb",
    "citySelect": "resultc",
    "day": "day",

}
